/**
 * localStorage keys shared between the React tree and the pure lib modules.
 *
 * They live here rather than in a hook so that node-testable modules (and the
 * pre-React boot path in main.tsx) can reference them without importing the
 * whole workspace context. `@/hooks/use-workspace` re-exports
 * ACTIVE_WORKSPACE_STORAGE_KEY so existing call sites keep working.
 */

/** Workspace the operator last selected. */
export const ACTIVE_WORKSPACE_STORAGE_KEY = "omni-active-workspace-id";

/**
 * Cached accent for that workspace. Only valid while it agrees with
 * ACTIVE_WORKSPACE_STORAGE_KEY — see workspace-branding-storage.ts.
 */
export const BRANDING_STORAGE_KEY = "omni-workspace-branding";
